module.exports = __webpack_public_path__ + "static/img/ewm1.d005d73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/softwares/ewm1.png
// module id = 1DVM
// module chunks = 6